import React, { useState, useEffect, useMemo } from "react";
import { NavLink } from "react-router-dom";
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from "react-icons/md";
import { useUserGroups, groupNamesFetched } from "../Auth/UserGroupsContext";

const SidebarMenu = ({ menuItems, groupNames: propGroupNames, groupFunctions, onClose }) => {
  const SDM_ADMIN = window?.userGroups?.mwqAdmin;
  const { groupNames } = useUserGroups();

  // PERFORMANCE FIX
  // Convert array to Set
  const groupSet = useMemo(() => {
    return new Set(groupNames || []);
  }, [groupNames]);

  const hasPermission = (groupCheck) => {
    // If groupCheck is undefined or an empty array, allow access
    if (!groupCheck || groupCheck.length === 0) return true;

    // //Allow access if the user is an admin
    // if (groupNames.some((role) => role === SDM_ADMIN)) {
    //   return true;
    // }

    // Check if any of the user's groups match the required roles
    //return groupCheck.some((role) => groupNames.includes(role));
    return groupCheck.some((role) => groupSet.has(role));
  };

  const hasFunction = (fnCheck) => {
    if (!fnCheck || fnCheck.length === 0) return true;

    //Allow access if the user is an admin
    // if (groupNames.some((role) => role === SDM_ADMIN)) {
    //   return true;
    // }
    if (groupSet.has(SDM_ADMIN)) {
      return true;
    }

    //return fnCheck.some((fnRole) => groupFunctions.includes(fnRole));
    return fnCheck.some(fnRole => groupFunctions?.includes(fnRole));
  };

  // return groupNames.length > 0 ? (
  return (
    <ul className="sidebar-menu mt-2">
      {menuItems.map((item, index) => {
        // Skip items if the main groupCheck doesn't match (if applicable)
        // if (item.groupCheck && !groupNames.includes(item.groupCheck)) {
        //   return null;
        // }

        if (!hasPermission(item.groupCheck)) {
          return null;
        }
        if (!hasFunction(item.funCheck)) {
          return null;
        }

        // If the item has subItems, check if at least one sub-item is visible
        let hasValidSubItem = false;
        // if (item.subItems) {
        //   //hasValidSubItem = groupNames.some((role) => role === SDM_ADMIN) || item.subItems.some(
        //     (subItem) =>
        //       hasPermission(subItem.groupCheck) && hasFunction(subItem.funCheck)
        //   );
        // }

        if (item.subItems) {
          hasValidSubItem =
            //(item.groupCheck && item.groupCheck.some((check) => groupNames.includes(check))) ||
            item.subItems.some(
              (subItem) =>
                hasPermission(subItem.groupCheck) && hasFunction(subItem.funCheck)
            );
        }

        // If the item has subItems but none are valid, skip rendering the main item
        if (item.subItems && !hasValidSubItem) {
          return null;
        }

        return (
          <li key={index} className="sidebar-item mt-2">
            <div
              onClick={item.toggle}
              className={`${item.isOpen ? "sidebar-link-active-parent" : "sidebar-link"
                }`}
            >
              {item.path ? (
                <span className="sidebar-text" onClick={onClose}>
                  <NavLink
                    to={item.path}
                    style={{ marginLeft: "-9px" }}
                    className={({ isActive }) =>
                      isActive
                        ? "sidebar-sublink active-link p-1 greenColorSidebar"
                        : "sidebar-sublink greenColorSidebar"
                    }
                  >
                    {item.label}
                  </NavLink>
                </span>
              ) : (
                <>
                  <span className="sidebar-text">{item.label}</span>
                  <span className="sidebar-icon">
                    {item.isOpen ? (
                      <MdKeyboardArrowDown
                        style={{ color: "white", marginBottom: "2px" }}
                        size={20}
                      />
                    ) : (
                      <MdKeyboardArrowRight
                        style={{ color: "white", marginBottom: "2px" }}
                        size={20}
                      />
                    )}
                  </span>
                </>
              )}
            </div>

            {item.subItems && item.isOpen && (
              <ul className="sidebar-submenu">
                {item.subItems.map((subItem, subIndex) => {

                  if (!hasPermission(subItem.groupCheck)) {
                    return null;
                  }

                  if (!hasFunction(subItem.funCheck)) {
                    return null;
                  }

                  return (
                    <li key={subIndex} className="sidebar-subitem" onClick={onClose}>
                      <NavLink
                        to={subItem.path}
                        className={({ isActive }) =>
                          isActive
                            ? "sidebar-sublink active-link"
                            : "sidebar-sublink"
                        }
                      >
                        {subItem.label}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            )}
          </li>
        );
      })}
    </ul>
  );
  // ) : null;
};

export default React.memo(SidebarMenu);
//export default SidebarMenu;
